import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faUser, faImage, faSave, faMailBulk, faBriefcase,faMailReply, faMessage } from '@fortawesome/free-solid-svg-icons';

const EditCollaborator = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email:'',
    jobTitle:'',
    photoUrl:null,
    projectIds:[],
    positionJEI:'',
    contactLink:'',  
  });

  useEffect(() => {
    if (id) {
      axios.get(`/collaborator/${id}`)
        .then(res => {
          const collaborator = res.data;
          setFormData({
            name: collaborator.name || '',
            photoUrl: collaborator.photoUrl || '', 
            email: collaborator.email || '',
            positionJEI:collaborator.positionJEI||'',
            contactLink:collaborator.contactLink||'',
            jobTitle: collaborator.jobTitle || '',
            projectIds: collaborator.projects ? collaborator.projects.map(p => p.id.toString()) : [],
          });
        })
        .catch(err => {
          console.error('Erreur chargement collaborator:', err);
          alert('Erreur chargement collaborator');
        });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFormData(prev => ({ ...prev, photoUrl: e.target.files[0] })); 
    }
  };

  const onCancel = (e) => {
    e.preventDefault();
    navigate('/admin/collaborators');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const data = new FormData();
      data.append('name', formData.name);
      data.append('jobTitle', formData.jobTitle);
      data.append('positionJEI', formData.positionJEI);
      data.append('email', formData.email);;
      data.append('contactLink', formData.contactLink);
if (formData.photoUrl instanceof File) {
        data.append('photoUrl', formData.photoUrl);
      }
      await axios.patch(`/collaborator/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Collaborator modifié avec succès !');
      navigate('/admin/collaborators');
    } catch (error) {
      console.error('Erreur modification collaborator:', error);
      alert('Erreur lors de la modification');

    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <button className="back-button" onClick={onCancel}>
          <FontAwesomeIcon icon={faArrowLeft} /> Retour
        </button>
        <h3>Modifier les infos du collaborator</h3>
      </div>

      <div className="form-card">
        <form onSubmit={handleSubmit} className="collaborator-form" encType="multipart/form-data">
          <div className="form-section">

            {/* Nom */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faUser} className="label-icon" /> Nom du collaborator
              </label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Entrez le nom du collaborator"
                className="form-input"
                required
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faMailBulk} className="label-icon" /> E-mail
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="L'e-mail du collaborator"
                className="form-input"
                required
              />
            </div>

            

            {/* PositionJEI */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faBriefcase} className="label-icon" /> PositionJEI
              </label>
              <input
                name="positionJEI"
                value={formData.positionJEI}
                onChange={handleChange}
                placeholder="membre"
                className="form-input"
                required
              />
            </div>

            {/* Poste */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faBriefcase} className="label-icon" /> Poste / métier (facultatif)
              </label>
              <input
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                placeholder="ingénieur"
                className="form-input"
              />
            </div>


            {/* contactLink */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faMessage} className="label-icon" /> Lien de contact (facultatif)
              </label>
              <input
                name="contactLink"
                value={formData.contactLink}
                onChange={handleChange}
                placeholder="Ex. profil LinkedIn ou site personnel"
                className="form-input"
              />
            </div>

            {/* Aperçu image */}
            {formData.photoUrl && (
              <div className="image-preview-section">
                <p className="image-label">Image actuelle :</p>
                <img
                  src={
                    formData.photoUrl instanceof File
                      ? URL.createObjectURL(formData.photoUrl)
                      : `/uploads/${formData.photoUrl}`
                  }
                  alt="Image du collaborator"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = '/defaults/defaultMemberImage.jpg';
                  }}
                  className="project-image"
                />
              </div>
            )}

            {/* Upload nouvelle image */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faImage} className="label-icon" /> Nouvelle image
              </label>
              <input
                type="file"
                name="photoUrl"
                accept="image/*"
                onChange={handleFileChange}
                className="form-input"
              />
            </div>

          </div>

          {/* Boutons */}
          <div className="form-actions">
            <button type="submit" className="btn-save">
              <FontAwesomeIcon icon={faSave} /> Enregistrer
            </button>
            <button type="button" className="cancel-button" onClick={onCancel}>
              <FontAwesomeIcon icon={faArrowLeft} /> Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCollaborator;
